export const DoughnutColor: string[] = ['#3B82F6', '#BDBDBD']
export const LineColor: string[] = ['#3B82F6', '#BDBDBD']
export const BarColor: string[] = ['#3B82F6', '#BDBDBD']
